/**
 * @todo: Candidate for including to a shared library.
 */
import { replace, trimEnd } from 'lodash-es';
/**
 * Normalize path by replacing multiple slashes with a single slash and removing trailing (end) slashes.
 */
const normalizePath = (path) => trimEnd(replace(path, /\/+/g, '/'), '/');
export default normalizePath;
